import React, { useState, useEffect } from 'react';

/*------------- IMPORTS FROM MATERIAL UI ------------------------------------*/
import Table from 'rsuite/Table';
import Pagination from 'rsuite/Pagination';
import Input from 'rsuite/Input';
import InputGroup from 'rsuite/InputGroup';
import Loader from 'rsuite/Loader';
import SearchIcon from '@rsuite/icons/Search';

/*------------- OTHERS ------------------------------------*/
import { useSelector, useDispatch } from 'react-redux';

/*------------- CUSTOM ------------------------------------*/
import './table.css';
import { RequestMisEmpresasAsync, selectIsLoading, selectData } from 'slices/empresaSlice';
import SectionPanel from 'Components/Common/SectionPanel/SectionPanel';
import { Tag } from 'rsuite';

const { Column, Cell, HeaderCell } = Table;
const PAGE = 1;
const PAGE_SIZE = 11;

export default function MisEmpresasTable() {
  const dispatch = useDispatch();
  const [limit] = useState(PAGE_SIZE);
  const [page, setPage] = useState(PAGE);
  const [searchValue, setSearchValue] = useState('');
  const [filter, setFilter] = useState({
    search: '',
    numberPage: PAGE,
    sizePage: PAGE_SIZE,
  });

  const isLoading = useSelector(selectIsLoading);
  const empresasData = useSelector(selectData);

  const handleSearch = () => {
    setFilter({ ...filter, search: searchValue, numberPage: 1 });
  };

  const handleChangePage = (value) => {
    setPage(value);
    setFilter({ ...filter, numberPage: value });
  };

  const renderLoading = () => {
    return (
      <div>
        <Loader backdrop center content="Cargado" />
      </div>
    );
  };

  useEffect(() => {
    dispatch(RequestMisEmpresasAsync(filter));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <SectionPanel
      title={
        <div className="table__hader">
          <h4>Mis Empresas</h4>
        </div>
      }
    >
      <div>
        <div className="table__hader">
          <div>
            <InputGroup className="table__header-input">
              <Input placeholder="Buscar" value={searchValue} onChange={(value) => setSearchValue(value)} />
              <InputGroup.Button onClick={handleSearch}>
                <SearchIcon />
              </InputGroup.Button>
            </InputGroup>
          </div>
        </div>
        <div className="table__body">
          <Table data={empresasData.items} fillHeight loading={isLoading} renderLoading={renderLoading}>
            <Column flexGrow={1}>
              <HeaderCell>NIT</HeaderCell>
              <Cell fullText dataKey="nit" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>NRC</HeaderCell>
              <Cell fullText dataKey="nrc" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Nombre</HeaderCell>
              <Cell fullText dataKey="nombre" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Nombre Comercial</HeaderCell>
              <Cell fullText dataKey="nombreComercial" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Teléfono</HeaderCell>
              <Cell dataKey="telefono" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Correo</HeaderCell>
              <Cell dataKey="correo" />
            </Column>
            {/* <Column flexGrow={1}>
              <HeaderCell>Estatus</HeaderCell>
              <Cell>
                {(rowData) =>
                  rowData.estatus === 100 ? (
                    <Tag color="yellow">Pendiente</Tag>
                  ) : rowData.estatus === 101 ? (
                    <Tag color="green">Activo</Tag>
                  ) : (
                    '-'
                  )
                }
              </Cell>
            </Column> */}
          </Table>
        </div>
        <div style={{ padding: 20 }}>
          <Pagination first next total={empresasData.recordsTotal} limit={limit} activePage={page} onChangePage={handleChangePage} />
        </div>
      </div>
    </SectionPanel>
  );
}
